// Every chat runs on the same model, and it sometimes copies its reasoning into the answer,
// wrapped in a <thought> or <thinking> tag, on top of the thoughts it streams separately. While
// the answer is still streaming the closing tag may not have arrived yet, so an unclosed block
// hides everything after it until it does.
const REASONING_BLOCK = /<(thought|thinking)>[\s\S]*?(?:<\/\1>|$)/gi;

export const stripReasoning = (answer: string): string => answer.replace(REASONING_BLOCK, "").trimStart();
